export default __webpack_public_path__ + "static/media/menu-cross-icon.9fb867c7.svg";